import { state } from "@mhmo91/schmancy/state";

export const passkeyEnrolled = state<string | null>(
	"auth/passkey-enrolled",
).local(null, { keepOnClear: true });
export const passkeyPhase = state<"idle" | "working" | "done" | "error">(
	"auth/passkey-phase",
).memory("idle");

export const passkeyPendingOffer = state<string | null>(
	"auth/passkey-pending-offer",
).session(null, { keepOnClear: true });

export const passkeyOfferOpen = state<boolean>(
	"auth/passkey-offer-open",
).memory(false);
